import React from 'react';
import { Spin, Tag } from 'antd';
import moment from 'moment';
import { humanize } from '@utils';
import { Wrapper, Cell, Label, Title, Content, Row, Value } from './styled';

export const Severities = {
  CRITICAL: { display: 'Critical', color: 'red' },
  WARNING: { display: 'Warning', color: 'orange' },
  INFO: { display: 'Info', color: 'blue' },
};

export const GetSeverityDisplay = (level: string) => {
  const Severity = Severities[level];
  if (Severity) {
    return <Tag color={Severity.color}>{Severity.display}</Tag>;
  }
  return 'Unknown';
};

const ImpactDetail = ({ detail, rootCause, loading }) => {
  const GenContent = (label, content) => {
    return (
      <Cell>
        <Label>{label}</Label>

        {loading ? <Spin></Spin> : <Value>{detail[content]}</Value>}
      </Cell>
    );
  };
  return (
    <Wrapper>
      <Title>{'Experience Alert & Impact Details'}</Title>
      <Content>
        <Row>
          {GenContent('Experience Metrics Affected', 'metrics')}
          <Cell>
            <Label>Time alert fired</Label>
            {loading ? (
              <Spin></Spin>
            ) : (
              <Value>{moment(detail.timeFired).format('hh:mm A MMM Do, YYYY')}</Value>
            )}
          </Cell>
        </Row>
        <Row>
          <Cell>
            <Label># Of Devices Impacted</Label>
            {loading ? <Spin></Spin> : <Value>{humanize(detail.impactedUsers)}</Value>}
          </Cell>
          {GenContent('Duration', 'duration')}
        </Row>
        <Row>
          <Cell>
            <Label>Severity</Label>
            {loading ? <Spin></Spin> : <Value>{GetSeverityDisplay(detail.severity)}</Value>}
          </Cell>
          <Cell>
            <Label>Suspected Root Cause</Label>
            {loading ? <Spin></Spin> : <Value>{rootCause}</Value>}
          </Cell>
        </Row>
      </Content>
    </Wrapper>
  );
};

export default ImpactDetail;
